import type { ParsedAddressComponents } from './types';

export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function parseNewApiComponents(addressComponents: any[]): ParsedAddressComponents {
  const result: ParsedAddressComponents = {};
  addressComponents.forEach((component) => {
    const types: string[] = component.types;
    if (types.includes('street_number')) result.streetNumber = component.longText;
    if (types.includes('route')) result.streetName = component.longText;
    if (types.includes('subpremise')) result.apartment = component.longText;
    if (types.includes('neighborhood')) result.city = component.longText;
    if (types.includes('administrative_area_level_1')) result.state = component.shortText;
    if (types.includes('postal_code')) result.zipCode = component.longText;
  });
  return result;
}

export function parseOldApiComponents(addressComponents: any[]): ParsedAddressComponents {
  const result: ParsedAddressComponents = {};
  addressComponents.forEach((component) => {
    const types: string[] = component.types;
    if (types.includes('street_number')) result.streetNumber = component.long_name;
    if (types.includes('route')) result.streetName = component.long_name;
    if (types.includes('subpremise')) result.apartment = component.long_name;
    if (types.includes('neighborhood')) result.city = component.long_name;
    if (types.includes('administrative_area_level_1')) result.state = component.short_name;
    if (types.includes('postal_code')) result.zipCode = component.long_name;
  });
  return result;
}

export function getPredictionText(prediction: any): { mainText: string; secondaryText: string } {
  return {
    mainText:
      prediction.placePrediction?.text?.text ||
      prediction.structured_formatting?.main_text ||
      prediction.description ||
      '',
    secondaryText:
      prediction.placePrediction?.structuredFormat?.secondaryText?.text ||
      prediction.structured_formatting?.secondary_text ||
      '',
  };
}
